module.exports = __webpack_public_path__ + "static/media/logo_dark.a28a8cc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo_dark.svg
// module id = 3
// module chunks = 0